import { selectQuizRaceIcon } from '@/assets/img/productSelectType'
import {
  activityIcon,
  appIcon,
  behaviorIcon,
  courseIcon,
  eventIcon,
  fastIcon,
  fileIcon,
  html5PNGIcon,
  linkIcon,
  operationsIcon,
  pdfIcon,
  processIcon,
  realTalkIcon,
  skillsIcon,
  videoIcon,
  workflowIcon,
} from '@/assets/img/productTypes'
import { productTypes } from './types'

const {
  ACT,
  ACTIVITY,
  AI_ASSISTANT,
  APP,
  ASSESSMENT,
  BEHAVIOR,
  DIALOGUE,
  FAST_SURVEY,
  FAST,
  FILE,
  HTML,
  LINK,
  MEET,
  OPERATIONS,
  PDF,
  PROCESS_ON_WEB,
  PROCESS,
  QUIZ_RACE,
  SCORM,
  SIM,
  SKILL,
  THIRDPARTY,
  VIDEO,
  WORKFLOW,
  REAL_TALK,
  REAL_TALK_MAKER,
  SKILLS_REAL_TALK,
  XAPI,
} = productTypes

export const simProductTypes = [
  ACT,
  BEHAVIOR,
  OPERATIONS,
  PROCESS,
  SKILL,
  SIM,
  WORKFLOW,
]

// Products that can be shared between companies via Company Relationships
// Excludes: MEET (Events), SCORM (Course), and FAST Suite products (FAST, ASSESSMENT, DIALOGUE, PROCESS_ON_WEB)
export const shareableProductTypes = [
  ACT,
  ACTIVITY,
  APP,
  BEHAVIOR,
  FILE,
  HTML,
  LINK,
  OPERATIONS,
  PDF,
  PROCESS,
  QUIZ_RACE,
  REAL_TALK,
  REAL_TALK_MAKER,
  SIM,
  SKILL,
  SKILLS_REAL_TALK,
  VIDEO,
  WORKFLOW,
]

const nonSimProductTypes = [
  ACTIVITY,
  FILE,
  HTML,
  LINK,
  MEET,
  PDF,
  QUIZ_RACE,
  SCORM,
  THIRDPARTY,
  VIDEO,
  XAPI,
]

export const filterProductTypes = [
  ACT,
  ASSESSMENT,
  BEHAVIOR,
  OPERATIONS,
  PROCESS,
  SKILL,
  WORKFLOW,
  FAST,
  QUIZ_RACE,
  XAPI,
  ACTIVITY,
  APP,
  MEET,
  FILE,
  LINK,
  PDF,
  VIDEO,
  DIALOGUE,
  PROCESS_ON_WEB,
  FAST_SURVEY,
  REAL_TALK,
  REAL_TALK_MAKER,
  SKILLS_REAL_TALK,
]

export const filterCertificateProducts = [
  ACT,
  ASSESSMENT,
  BEHAVIOR,
  OPERATIONS,
  PROCESS,
  SKILL,
  WORKFLOW,
  FAST,
  QUIZ_RACE,
  XAPI,
  ACTIVITY,
  APP,
  MEET,
  FILE,
  LINK,
  PDF,
  VIDEO,
  DIALOGUE,
  REAL_TALK,
  REAL_TALK_MAKER,
  SKILLS_REAL_TALK,
]

const deletableProductTypes = [
  ACTIVITY,
  APP,
  FILE,
  HTML,
  LINK,
  MEET,
  PDF,
  QUIZ_RACE,
  SCORM,
  THIRDPARTY,
  VIDEO,
  XAPI,
  FAST,
  DIALOGUE,
  FAST_SURVEY,
]

export const isFileUploadProduct = (productType) => {
  return [PDF, VIDEO, LINK, FILE, QUIZ_RACE].includes(productType)
}

export const isNonSimProduct = (productType) => {
  return nonSimProductTypes.includes(productType)
}

export const isSimProduct = (productType) => {
  return simProductTypes.includes(productType)
}

export const canProductBeDeleted = (productType, isProductShared) => {
  return deletableProductTypes.includes(productType) && !isProductShared
}

export const isAttensiProduct = (productType) => {
  return simProductTypes.includes(productType)
}

export const getProductTypeIcon = (productType) => {
  switch (productType) {
    case ACTIVITY:
      return activityIcon
    case ACT:
      return courseIcon
    case APP:
      return appIcon
    case BEHAVIOR:
      return behaviorIcon
    case FILE:
      return fileIcon
    case HTML:
      return html5PNGIcon
    case LINK:
      return linkIcon
    case MEET:
      return eventIcon
    case OPERATIONS:
      return operationsIcon
    case PDF:
      return pdfIcon
    case PROCESS:
      return processIcon
    case SCORM:
      return courseIcon
    case SIM:
      return behaviorIcon
    case SKILL:
      return skillsIcon
    case THIRDPARTY:
      return courseIcon
    case VIDEO:
      return videoIcon
    case WORKFLOW:
      return workflowIcon
    case XAPI:
      return courseIcon
    case QUIZ_RACE:
      return selectQuizRaceIcon
    case FAST:
      return fastIcon
    case ASSESSMENT:
      return fastIcon
    case PROCESS_ON_WEB:
      return fastIcon
    case DIALOGUE:
    case AI_ASSISTANT:
      return fastIcon // update to proper icon
    case REAL_TALK:
    case REAL_TALK_MAKER:
    case SKILLS_REAL_TALK:
      return realTalkIcon
    default:
      return courseIcon
  }
}
